import { useMemo, useState, useCallback } from 'react'
import { ActivationContext } from './context/activationContextObject'

const CABINET_STORAGE_KEY = 'vammo_cabinet_data'

function readStoredCabinet() {
  const raw = sessionStorage.getItem(CABINET_STORAGE_KEY)
  if (!raw) return { cabinetSerial: null, slotPosition: null }

  try {
    const parsed = JSON.parse(raw)
    return {
      cabinetSerial: parsed.cabinetSerial || null,
      slotPosition: Number.isInteger(parsed.slotPosition) ? parsed.slotPosition : null,
    }
  } catch {
    return { cabinetSerial: null, slotPosition: null }
  }
}

export function ActivationProvider({ children }) {
  const [cabinetState, setCabinetState] = useState(readStoredCabinet)

  const setCabinetData = useCallback((serial, slot) => {
    const nextState = {
      cabinetSerial: serial,
      slotPosition: slot,
    }

    sessionStorage.setItem(CABINET_STORAGE_KEY, JSON.stringify(nextState))
    setCabinetState(nextState)
  }, [])

  const clearCabinetData = useCallback(() => {
    sessionStorage.removeItem(CABINET_STORAGE_KEY)
    setCabinetState({ cabinetSerial: null, slotPosition: null })
  }, [])

  const value = useMemo(
    () => ({
      cabinetSerial: cabinetState.cabinetSerial,
      slotPosition: cabinetState.slotPosition,
      setCabinetData,
      clearCabinetData,
    }),
    [cabinetState.cabinetSerial, cabinetState.slotPosition, setCabinetData, clearCabinetData],
  )

  return <ActivationContext.Provider value={value}>{children}</ActivationContext.Provider>
}
